import { styled } from 'theme'

export const SvgCircleWrap = styled('div', {
  display: 'flex',
  alignItems: 'center',
  p: '$space$8',
  borderRadius: '$radii$rounded',

  variants: {
    color: {
      primary: {
        background: '$primaryBgSubtle',
        borderColor: '$primary50',
        svg: {
          path: {
            stroke: '$primaryBase',
          },
        },
      },
      secondary: {},
      gray: {
        background: '$gray100',
        borderColor: '$gray50',
        svg: {
          path: {
            stroke: '$gray600',
          },
        },
      },
      warning: {
        background: '$warningBg',
        borderColor: '$warning50',
        svg: {
          path: {
            stroke: '$warning',
          },
        },
      },
      error: {
        background: '$errorBg',
        borderColor: '$error50',
        svg: {
          path: {
            stroke: '$error',
          },
        },
      },
      success: {
        background: '$successBg',
        borderColor: '$success50',
        svg: {
          path: {
            stroke: '$success',
          },
        },
      },
      transparent: {},
      black: {},
      white: {},
      disabled: {},
    },
  },
  defaultVariants: {
    color: 'primary',
  },
})
